<template>
  <div v-if="!isPrint">
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!-- 교육내용 -->
    <div>
      <vs-row class="mt-6 mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 교육내용</h5>
        </vs-col>
      </vs-row>

      <div class="writeGridContainer">
        <div>
          <div>교육구분</div>
          <custom-option-selector :readonly="board.readonly" v-model="form.education_type" @select="changeTarget1" :options="diff" />
        </div>
        <div v-if="!!form.education_type && 1 < diff[form.education_type.index].child.length" class="writeGridLineItem">
          <div>대상(작업명)</div>
          <custom-option-selector
            :readonly="board.readonly"
            v-model="form.target_work"
            :options="diff[form.education_type.index].child"
            placeholder="1. 고압실 내 작업(잠함공법이나 그 밖의 압기공법으로 대기압을 넘는 기압인 작업실 또는 수갱 내부에서 하는 작업만 해당한다)"
            @select="changeTarget2"
          />
        </div>
        <div>
          <div>교육명</div>
          <ml-input v-model="form.education_name" :readonly="board.readonly" placeholder="입력필드" />
        </div>
        <div>
          <div>교육기간</div>
          <div class="time">
            <date-selector v-model="form.교육기간.시작" :readonly="board.readonly" />
            <span>~</span>
            <date-selector v-model="form.교육기간.종료" :readonly="board.readonly" />
          </div>
        </div>
        <div>
          <div>실적시간</div>
          <div class="flex gap-2" style="align-items: center;">
            <number-input v-model="form.실적시간.시간" :readonly="board.readonly" type="number" :min="0" />
            <span class="whitespace-no-wrap">시간</span>
            <number-input v-model="form.실적시간.분" :readonly="board.readonly" type="number" :min="0"/>
            <span class="whitespace-no-wrap">분</span>
          </div>
        </div>
        <div>
          <div>교육장소</div>
          <ml-input v-model="form.education_location" :readonly="board.readonly" placeholder="입력필드" />
        </div>
      </div>
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div>교육내용에 반영한 재해형태(필수)</div>
          <disaster-class-selector :multiple="true" :readonly="board.readonly" :addData="['직접입력']" placeholder="입력필드" v-model="form.reflected_disaster_type" />
        </div>
      </div>
      <div class="writeGridContainer">
        <div>
          <div>교육 실시자 성명</div>
          <ml-input v-model="form.instructor_full_name" :readonly="board.readonly" placeholder="입력필드" />
        </div>
        <div>
          <div>교육 실시자 소속</div>
          <ml-input v-model="form.instructor_affiliation" :readonly="board.readonly" placeholder="입력필드" />
        </div>
        <div>
          <div>교육 실시자 직책</div>
          <ml-input v-model="form.instructor_position" :readonly="board.readonly" placeholder="입력필드" />
        </div>
        <div>
          <div>교육 대상</div>
          <ml-input v-model="form.education_target" :readonly="board.readonly" placeholder="입력필드" />
        </div>
        <div>
          <div>교육 실시 인원</div>
          <comma-input v-model="form.participants_attended" type="number" :readonly="board.readonly" placeholder="입력필드" />
          <p>명</p>
        </div>
        <div>
          <div>교육 미실시 인원</div>
          <comma-input v-model="form.participants_not_attended" type="number" :readonly="board.readonly" />
          <p>명</p>
        </div>
        <div class="writeGridLineItem">
          <div>교육내용</div>
          <ml-textarea rows="5" v-model="form.education_content" :readonly="board.readonly" />
        </div>
        <div class="writeGridLineItem">
          <div>근로자 의견</div>
          <ml-textarea rows="5" v-model="form.worker_opinion" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!-- 참석자 명단 -->
    <table-custom
      :default-size="0"
      :controls="true"
      :multiple="true"
      :board="board"
      :is-print="isPrint"
      title="참석자 명단"
      :tableData="[
        { id: 'employee_id', title: 'ID(사번)', type: 'fixed-text', placeholder: '' },
        { id: 'com_name', title: '부서명', type: 'fixed-text', placeholder: '' },
        { id: 'employment_type', title: '직종', type: 'fixed-text', placeholder: '' },
        { id: 'full_name', title: '이름', type: 'fixed-text', placeholder: '' },
        { id: 'note', title: '비고', type: 'text', placeholder: '' },
      ]"
      :mobile="['com_name', 'full_name']"
      v-model="employeeList"
      class="mt-4"
      :button-add-name="'참석자 등록'"
      :custom-add-handler="true"
      :custom-remove-handler="true"
      @add-row="onClickAddEmployee"
      @remove-row="onClickRemoveEmployee"
    />

    <!-- 확인자 -->
    <div>
      <h5 class="mt-6 mb-4"><i class="dot"></i> 확인자</h5>
      <div class="writeGridContainer">
        <div>
          <div>관리감독자</div>
          <ml-input v-model="form.sign1.name" :readonly="board.readonly" />
        </div>
        <div>
          <div>서명</div>
          <sign-field v-model="form.sign1.sign" :readonly="board.readonly" />
        </div>
      </div>
      <div class="writeGridContainer">
        <div>
          <div>담당자</div>
          <ml-input v-model="form.sign2.name" :readonly="board.readonly" />
        </div>
        <div>
          <div>서명</div>
          <sign-field v-model="form.sign2.sign" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!-- 사진대지 -->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" section-title="교육 사진" placeholder="신축현장 점검" />

    <file-upload-module title="서명부 등 파일첨부" id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>

    <popup-search-employee-checkbox v-model="showPopup" :initSelectedEmployees="JSON.parse(JSON.stringify(employeeList))" @handleClickSelect="handleEmployeeSelect" />
  </div>
  <print v-else :form="form" :employeeList="employeeList" />
</template>

<script>
import DateSelector from "@/components/selector/DateSelector";
import TimeSelector from "@/components/selector/TimeSelector";
import CustomOptionSelector from "@/components/selector/CustomOptionSelectorObject";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import Print from "./Print.vue";

import KPagination from "@/components/kPagination/kPagination";
import SearchNavStartEnd from "@/components/nav/SearchNavStartEnd.vue";
import SearchNavItemKeyword from "@/components/nav/SearchNavItemKeyword";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect";
import { valueDisasters } from "@/util/DisasterDataUtil";
import TableCustom from "@/components/TableCustom.vue";
import diffData from "./DiffData";
import SignField from "@/components/SignField.vue";
import PopupSearchEmployeeCheckbox from "@/popup/PopupSearchEmployeeCheckbox.vue";
import moment from "moment";
import NumberInput from "@/components/NumberInput.vue";
import {required} from "vuelidate/lib/validators";

export default {
  components: {
    NumberInput,
    PopupSearchEmployeeCheckbox,
    Print,
    PhotoUploadGridModule,
    FieldSelectModule,
    CustomOptionSelector,
    FileUploadModule,
    DateSelector,
    DisasterClassSelector,
    TimeSelector,
    KPagination,
    SearchNavStartEnd,
    SearchNavItemKeyword,
    SearchNavItemSelect,
    TableCustom,
    SignField,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      stdInfo:{
        field_name: { required },
      },
      selectedEmployees: { required },
    }
  },
  data() {
    return {
      // =============== 이전 문서 불러오기 ===============
      isMounted: false,
      customButton: null,
      showPopup: false,
      disasterTypes: [{ text: "전체선택", value: "" }, ...valueDisasters()],
      searchTypes: [
        { value: "stdInfo.field_name", text: "현장명" },
        { value: "inputD_1", text: "재해일시" },
        { value: "inputD_3", text: "발생형태" },
        { value: "stdInfo.department", text: "소속명" },
        { value: "stdInfo.com_name", text: "부서명" },
        { value: "stdInfo.writer_name", text: "작성자" },
      ],
      // 페이징
      page: {
        current: 1,
        lastPage: 1,
        perPage: 10,
      },
      // 검색
      search: {
        date: "", // 작성일
        disasterType: "", // 발생형태
        searchType: "", // 검색조건
        searchKeyword: "", // 키워드
      },

      // 종사자 정보
      employeeList: [],
      loadEmployee: false,

      // =============== FORM ===============
      diff: diffData,
      form: {
        stdInfo: {},

        education_type: null,
        target_work: null,

        education_name: "",
        education_date: "",
        education_start_time: "",
        education_end_time: "",
        education_location: "",
        reflected_disaster_type: [],
        instructor_full_name: "",
        instructor_affiliation: "",
        instructor_position: "",
        education_target: "",
        participants_attended: "",
        participants_not_attended: "",
        education_content: "",
        worker_opinion: "",
        disaster_type_direct_input: "",
        // 교육 시간
        educationHours: 0,

        selectedEmployees: [],
        photoList: [],
        fileList: [],
        signatureList: [],
        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
        disasters: "",

        // 추가
        실적시간: {
          시간: 0,
          분: 0,
        },
        교육기간: {
          시작: 0,
          종료: 0,
        }
      },
    };
  },
  computed: {
    // computed
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        if (value) {
          const keys = Object.keys(value);
          for (const key of keys) {
            if (value[key]) {
              this.form[key] = value[key];
            }
          }

          // 교육 시간을 갱신한다
          // education_start_time 시각(10:00:00)으로부터 education_end_time 시각(16:00:00)까지 경과된 시간을 "실적시간.시간", "실적시간.분" 에 저장한다
          this.updateEducationHours();

          // 교육일(education_date) 값이 존재하고, "교육기간.시작" 값이 존재하지 않는 경우, "교육기간.시작" 값을 "education_date" 값으로 설정한다)
          if (this.value.education_date && !this.form.교육기간.시작) {
            this.form.교육기간.시작 = this.value.education_date;
          }
          // 교육일(education_date) 값이 존재하고, "교육기간.종료" 값이 존재하지 않는 경우, "교육기간.종료" 값을 "education_date" 값으로 설정한다)
          if (this.value.education_date && !this.form.교육기간.종료) {
            this.form.교육기간.종료 = this.value.education_date;
          }
        }
      },
    },
    /**
     * 종사자 목록이 갱신되면, form 내에는 ID 값만 추출해서 보관한다.
     * 종사자 정보 중에는 암호화되어 있는 데이터가 있기 때문에, 모든 정보를 보관하면 보안상 문제가 발생할 수 있다.
     * {id: 1, note: '비고'} 형식으로 변환한다
     */
    employeeList: {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.selectedEmployees = value.map((item) => {
          return { id: item.id, note: item.note };
        });
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.summary = {
          안전보건교육_현장명: [],
          안전보건교육_재해형태: [],
          안전보건교육_교육구분: [],
          안전보건교육_현장별교육구분: [],
          안전보건교육_현장별재해형태: [],
        };

        value.summary["안전보건교육_현장명"].push({
          [this.form.stdInfo.field_name]: 1,
        });

        if (this.form.education_type) {
          value.summary["안전보건교육_교육구분"].push({
            [this.form.education_type.value]: 1,
          });

          value.summary["안전보건교육_현장별교육구분"].push({
            [`${this.form.stdInfo.field_name}_${this.form.education_type.value}`]: 1,
          });
        }

        if (this.form.reflected_disaster_type && this.form.reflected_disaster_type.length > 0) {
          for (const data of this.form.reflected_disaster_type) {
            value.summary["안전보건교육_재해형태"].push({
              [data]: 1,
            });

            value.summary["안전보건교육_현장별재해형태"].push({
              [`${this.form.stdInfo.field_name}_${data}`]: 1,
            });
          }
        }

        // 문서에는 종사자 ID 값만 보관되어 있다.
        // ID 값에 해당하는 종사자 목록을 불러오도록 한다
        this.initEmployeeList();

        // 교육 시간을 갱신한다
        this.updateEducationHours();

        this.$emit("input", value);
      },
    },
  },
  created () {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.field_name.required) {
          alert("사업장명을 선택해주세요");
        }
        else if (!this.$v.form.selectedEmployees.required) {
          alert("참석자 명단에 참석자를 등록 후 저장 해주세요");
        }

        return false;
      } else {
        // 유효성 검사가 성공한 경우
        return true;
      }
    },
    /**
     * 문서를 불러왔을 때 사용된다.
     * 문서에는 보안을 위해서, 종사자 ID 값만 보관되어 있다.
     * ID 값에 해당하는 종사자 목록을 불러오도록 한다
     */
    initEmployeeList() {
      if (this.loadEmployee) return;
      // 문서에서 불러온 종사자 정보(id)가 있지만, 종사자 목록이 비어있는 경우
      if (this.form.selectedEmployees && this.form.selectedEmployees.length > 0 && this.employeeList.length === 0) {
        this.loadEmployee = true;
        const page = 1;
        const perPage = this.form.selectedEmployees.length;
        const projectId = this.projectId;
        const ids = this.form.selectedEmployees.map((item) => item.id);

        const payload = { projectId, page, perPage, ids };

        this.$store.dispatch("employee/LOAD_EMPLOYEE_LIST", payload).then((result) => {
          this.loadEmployee = false;
          if (result.data) {
            this.employeeList = result.data;

            // this.form.selectedEmployees 아이템의 id가 일치하는 this.employeeList 아이템에 note 값을 추가한다
            for (const item of this.form.selectedEmployees) {
              const index = this.employeeList.findIndex((employee) => employee.id === item.id);
              if (index > -1) {
                this.employeeList[index].com_name = this.employeeList[index].company.com_name;
                this.employeeList[index].note = item.note;
              }
            }
          }
        });
      }
    },

    // education_start_time 시각(10:00:00)으로부터 education_end_time 시각(16:00:00)까지 경과된 시간을 form.educationHours 에 저장한다
    updateEducationHours() {
      if (this.form.education_start_time && this.form.education_end_time) {
        const start = moment(this.form.education_start_time, "HH:mm:ss");
        const end = moment(this.form.education_end_time, "HH:mm:ss");
        const duration = moment.duration(end.diff(start));
        const hours = duration.asHours();

        // 만약 hours 값이 0보다 작다면 0으로 설정한다
        // this.form.educationHours = hours < 0 ? 0 : hours;

        // 시간
        this.form.실적시간.시간 = Math.floor(hours);
        // 분
        this.form.실적시간.분 = Math.floor((hours - Math.floor(hours)) * 60);
      }

      if (this.form.실적시간.시간 || this.form.실적시간.분) {
        this.form.educationHours = Number((this.form.실적시간.시간 || 0)) + Number(((this.form.실적시간.분 || 0) / 60));
      }
    },

    // ======================= FORM =======================
    changeTarget1() {
      if (!this.form.education_type) return;
      if (1 === this.diff[this.form.education_type.index].child.length) {
        this.form.education_content = this.diff[this.form.education_type.index].child[0].textarea;
      } else {
        this.form.target_work = null;
        this.form.education_content = "";
      }
    },
    changeTarget2() {
      if (!!this.form.education_type && !!this.form.target_work) this.form.education_content = this.diff[this.form.education_type.index].child[this.form.target_work.index].textarea;
    },
    onClickAddEmployee() {
      this.showPopup = true;
    },
    onClickRemoveEmployee(checkData) {
      // checkData의 배열에 있는 값과 this.employeeList의 id가 같은 것이 제거되도록 this.employeeList를 수정한다
      this.employeeList = this.employeeList.filter((item) => !checkData.includes(item.id));
    },
    handleEmployeeSelect(datas) {
      if (this.employeeList.length > 0) {
        if (datas.length > 0) {
          const adds = datas.filter((v, i) => {
            for (const emp of this.employeeList) {
              if (emp.id === v.id) {
                return false;
              }
            }
            return true
          });

          this.employeeList.push(...adds.map((item) => {
            return {
              id: item.id,
              employee_id: item.employee_id,
              com_name: item.com_name ? item.com_name : item.company.com_name,
              field_name: item.field_name ? item.field_name : item.fields.length > 0 ? item.fields[0].field_name : "",
              employment_type: item.employment_type,
              full_name: item.full_name,
            };
          }));
        }
      } else {
        this.employeeList = datas.map((item) => {
          return {
            id: item.id,
            employee_id: item.employee_id,
            com_name: item.com_name ? item.com_name : item.company.com_name,
            field_name: item.field_name ? item.field_name : item.fields.length > 0 ? item.fields[0].field_name : "",
            employment_type: item.employment_type,
            full_name: item.full_name,
          };
        });
      }
      const newList = JSON.parse(JSON.stringify(this.employeeList))
      this.employeeList = newList.filter((v, i) => newList.indexOf(v).id === i.id);

      this.form.participants_attended = this.employeeList.length
    },
  },
};
</script>
